var _style, _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpArrowCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 73.3 73.3",
    style: {
      enableBackground: "new 0 0 73.3 73.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#008C9E;}\r\n\t.st1{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:3;stroke-miterlimit:10;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 36.7,
    cy: 36.7,
    r: 36.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.4,43.4l2,1.9c0.6,0.7,1.7,0.7,2.3,0l0,0l12.1-12.1c0.7-0.7,1.7-0.7,2.5,0l0,0l11.5,12.1 c0.6,0.7,1.7,0.7,2.3,0.1l0,0l2.2-1.8c0.7-0.6,0.7-1.7,0.1-2.2l0,0l-16-16.7c-0.6-0.7-1.7-0.7-2.3,0l0,0L19.4,41.4 C18.6,41.7,18.6,42.8,19.4,43.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrowCircle);
export default __webpack_public_path__ + "static/media/up-arrow-circle.a714fa98157cf82594f0c75aa2747805.svg";
export { ForwardRef as ReactComponent };